import {
  AccountAnalyticsButton,
  AccountLanguagesButton,
  AccountUsers2FAButton,
  JourneyPageSettingsForm,
} from './forms'
import { useStyles } from './styles'

const MobileSettings = () => {
  const classes = useStyles()

  return (
    <div className={classes.settingsWrapper}>
      <AccountLanguagesButton mobile />
      <AccountUsers2FAButton mobile />
      <AccountAnalyticsButton mobile />
      <JourneyPageSettingsForm mobile />
    </div>
  )
}

export { MobileSettings }
